<template>
  <div class="container">
    <nav class="navbar fixed-top bg-light">
        <div class="col my-2 px-0 input-group">
          <input class="form-control" type="search" v-model="filter" placeholder="Search" ref="search">
          <div class="input-group-append">
            <button class="btn btn-outline-info" type="button" @click="$router.push('/contacts')"><i class="fas fa-building"></i></button>
          </div>
        </div>
        <div class="col px-0">
          <router-link :to="'/customers/add'" class="btn btn-sm btn-info float-right">
            <i class="fas fa-plus"></i>
          </router-link>
        </div>
    </nav>

    <div class="list-group" id="cust-list">
      <router-link :to="'/customers/' + cust.CustomerId" class="list-group-item list-group-item-action" v-for="cust in customers" :key="cust.CustomerId">{{ cust.Name }}</router-link>
    </div>
  </div>
</template>

<script>
import appService from '@/appService'

export default {
  name: 'CustomerList',
  data () {
    return {
      filter: '',
      customers: []
    }
  },

  mounted() {
    this.$refs.search.focus()
  },

   watch: {
    filter: function() {
      if (this.filter.length > 0) {
        appService.searchCustomers(this.filter).then(res => this.customers = res)
      }
    }
  }
}
</script>
<style>
#cust-list {
  padding-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerList.vue